'use strict';

namespace Core.Customer {

    import CrossSellType = Core.Booking.CrossSellType;

    class CrossSellSetting {
        public readonly captionResourceKey :string | null;
        public readonly tagLineResourceKey :string | null;
        public readonly iconClass :string;

        constructor(iconClass :string, captionResourceKey? :string, tagLineResourceKey? :string) {
            this.iconClass = iconClass;
            this.captionResourceKey = captionResourceKey || null;
            this.tagLineResourceKey = tagLineResourceKey || null;
        }
    }

    class CrossSellCard {

        private readonly crossSellSettings :{[id: number]: CrossSellSetting} = {};
        private layout :string;
        private model :CrossSellOption;

        public caption :string;
        public cssClass :string;
        public icon :string;
        public tagline: string | null;
        public teaserPrice :number;

        constructor(private $scope :ng.IScope,
                    private $location :ng.ILocationService,
                    private crossSellCommonService :any,
                    private resourceService :ResourceService) {

            //set up our settings
            this.crossSellSettings[CrossSellType.Attractions] = new CrossSellSetting('attractions');
            this.crossSellSettings[CrossSellType.Baggage] =
                        new CrossSellSetting('baggage', 'CROSSSELL_BAGS_CAPTION', 'CROSSSELL_BAGS_TAGLINE');
            this.crossSellSettings[CrossSellType.CarHire] =
                        new CrossSellSetting('car-hire', 'CROSSSELL_CARHIRE_CAPTION', 'CROSSSELL_CARHIRE_TAGLINE');
            this.crossSellSettings[CrossSellType.Hotels] =
                        new CrossSellSetting('hotels', 'CROSSSELL_HOTEL_CAPTION');
            this.crossSellSettings[CrossSellType.Parking] =
                        new CrossSellSetting('parking', 'CROSSSELL_PARKING_CAPTION', 'CROSSSELL_PARKING_TAGLINE');
            this.crossSellSettings[CrossSellType.Seats] =
                        new CrossSellSetting('seating', 'CROSSSELL_SEATS_CAPTION', 'CROSSSELL_SEATS_TAGLINE');
            this.crossSellSettings[CrossSellType.Transfers] =
                        new CrossSellSetting('transfers', 'CROSSSELL_TRANSFER_CAPTION', 'CROSSSELL_TRANSFER_TAGLINE');

            this.cssClass = (this.layout === 'tall') ? 'cross-sell-card-tall' : 'cross-sell-card-wide';

            let watch = $scope.$watch('csc.model', m => {
                if (m) {
                    const settings= this.crossSellSettings[this.model.CrossSellType];
                    this.icon = settings.iconClass;
                    this.teaserPrice = this.model.TeaserPrice;

                    if (settings.captionResourceKey) {
                        this.caption = this.resourceService.get(settings.captionResourceKey);
                    } else if (this.model instanceof Customer.CrossSellProductOption) {
                        this.caption = this.model.Title;
                    }

                    if (settings.tagLineResourceKey !== null) {
                        this.tagline = this.resourceService.get(settings.tagLineResourceKey) || null;
                    }

                    if (this.model instanceof Customer.CrossSellHotelOption) {
                        this.tagline = this.model.Title;
                    }

                    watch();
                }
            });

        }

        public click() :void {
            if (this.model instanceof Customer.CrossSellFlightExtraOption) {
                this.$location.url(this.model.Url);
            } else if (this.model instanceof Customer.CrossSellProductOption) {
                this.crossSellCommonService.startCrossSellJourney(this.model.BookingId, this.model.ProductDetails);
            }
        }
    }
    angular
        .module('core')
        .directive('crossSellCard', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: CrossSellCard,
                controllerAs: 'csc',
                bindToController: {
                    model: '=',
                    layout: '@'
                },
                templateUrl: 'partials/customer/crosssellcard'
            };
        });
}
